<script>
  import { Input } from "sveltestrap";
  export let index,
    inputFocusAction,
    inputBlurAction,
    domain_values,
    currEncFieldType,
    afterScaleUpdate;
</script>

<Input
  type={currEncFieldType === "number" ? "number" : "text"}
  name={"scale_domain_" + index}
  class="custom-form-select"
  style="border-right: 1px solid #dddddd !important;"
  autocomplete="off" 
  on:focus={inputFocusAction}
  on:blur={inputBlurAction}
  bind:value={domain_values[index]}
  on:change={afterScaleUpdate}
/>
